import React from 'react';

function NoPage() {
    return (
        <div>
            <div>Error 404</div>
        </div>
    );
}
export default NoPage;